import moment from "moment"
import "moment/locale/en-gb"
import "moment/locale/fr"
import "moment/locale/nl"
import React, { useEffect } from "react"
import { IntlProvider } from "react-intl"
import { connect } from "react-redux"

import { Locales, translations } from "../../../i18n/config"
import { getCurrentUserLocale } from "../../redux/currentUser/currentUser.selectors"
import IState from "../../redux/state"

type ConnectedIntlProviderProps = {
  locale: Locales
}

function ConnectedIntlProvider({ locale, children }: React.PropsWithChildren<ConnectedIntlProviderProps>): JSX.Element {
  useEffect(() => {
    moment.locale(locale)

    // Set English to use Brittish variant.
    if (moment.locale() === Locales.EN) {
      moment.updateLocale(Locales.EN, {
        week: {
          dow: 1,
        },
      })
    }
  }, [locale])

  return (
    <IntlProvider messages={translations[locale]} locale={locale}>
      {children}
    </IntlProvider>
  )
}

const mapStateToProps = (state: IState) => ({
  locale: getCurrentUserLocale(state),
})

export default connect(mapStateToProps)(ConnectedIntlProvider)
